// extracted by css-extract-rspack-plugin
export default {"link":"HtAFa4qgO81fAEU6","icon":"b_Chgrj_FhodlAd1","label":"WiYerjbGPI20jS7f"};